_ = (l) ->
  console.log l
  l

Loader = 
  loading : false
  finished : (fun) ->
    Tone.Buffer.off "load"
    @loading = true
    Tone.Buffer.on "load", (e) =>
      Tone.Buffer.off "load"
      @loading = false
      fun(e)


Samples = 
  buttons : []
  back : null
  empty : null
  buffercount : 0
  loadcount : 1
  loaded_buffer : () ->
    @loadcount += 1
    # $("#time").html ($("#time").html() + ".")
    pc = Math.floor((@loadcount / (@buffercount+1)) * 100)
    # $("#time").html "#{pc}%"
    $("#time").html "Solvator készül"
  url_exists : (url) ->
    # o = await fetch(url)
    # o.ok
    http = new XMLHttpRequest()
    http.open('HEAD', url, false)
    http.send()
    http.status isnt 404
  get : (url) ->
    # if await @url_exists url
    if @url_exists url
      console.log "loading #{url}"
      # @buffercount += 1
      new Tone.Buffer(url, @loaded_buffer.bind(@))
    else 
      @empty
  load : (callback) ->
    @empty = @get "./samples/_empty.mp3"
    @back = @get "./samples/vissza.mp3"
    for i in [0..9]
      @buttons.push @get("./samples/#{i}.mp3")  

    @buffercount = 10 + 2
    Map.load Mapdata #HACK
    # Looper.load @loaded_buffer.bind(@)

    Loader.finished callback

class Node
  @load : (data) ->
    new Node(data[0], data[1], data[2], data[3])

  get_output : (i) -> if i < @outputs.length then @outputs[i] else null
  is_looper : () -> @name.substr(0, 6) is "looper"
  is_story : () -> @name.substr(0, 2) is "k_"

  constructor : (@name, @parent, @outputs, @info) ->

  toString : () ->
    outs = 
      for o, i in @outputs
        if Map.nodes[o]?
          "#{i + 1} : #{Map.nodes[o].info}"
        else 
          ""
    @info + "\n" + outs.join "\n"

class Track
  constructor : () ->
    @player = new Tone.Player(loop : true, volume : -6).connect Tone.Master
  toggle : () -> @player.mute = !@player.mute

Looper = 
  tracks : [1..9].map (i) -> new Track()
  buffers : [1..9].map (i) -> new Tone.Buffer()

  current_song : -1
  current : 0

  play_song : (song_index) ->
    console.log "loading looper", song_index
    @current_song = song_index
    for b, i in @buffers
      b.dispose()
      loop_url = "./samples/looper/#{song_index}/#{i + 1}.mp3"
      console.log "loading #{loop_url}"
      b.load loop_url
        .then (e) -> console.log e
        .catch (e) -> console.log "MISSING LOOP", loop_url

    Loader.finished @init.bind(@)

  start : () -> @tracks.map((t) -> if t.player.buffer? and t.player.buffer.loaded then t.player.start())
  stop : () -> 
    @tracks.map((t) -> t.player.stop())

  init : (s) ->
    console.log "initing looper"
    for t, i in @tracks
      t.player.buffer = @buffers[i]
      t.player.mute = i isnt 0
    Looper.start()
  toggle : (i) ->
    if 0 < i < @tracks.length + 1
      @tracks[i - 1].toggle()
      Map.save_action "looper#{@current_song}:#{i}"

Visual = 
  mode : "wave" #"text" # "wave"
  waveform : null
  ctx : null
  hsl : (h, s, l, a) -> 
   "hsl(#{h * 360}, #{s * 100}%, #{l * 100}%, #{a})"
  loops : (w, h) ->
    sw = w / 3
    sh = h / 3
    for l in [0..8]
      @ctx.fillStyle = 
        if Looper.tracks[l].player.mute
          "#6244"
        else
          @hsl 0.9 + Math.random() * 0.2, 0.8 + Math.random() * 0.1, 0.3, 0.2 + Math.random() * 0.2
      @ctx.fillRect((l % 3) * sw, Math.floor(l / 3) * sh, sw, sh)
  draw_waveform : (values) ->
    w = @ctx.canvas.width
    h =  @ctx.canvas.height
    # @ctx.clearRect(0, 0, w, h)
    @ctx.fillStyle = "#6244"
    @ctx.fillRect(0, 0, w, h)
    if Map.current? and Map.current.is_looper()
      @loops w, h
    # if Player.
    @ctx.lineJoin = "bezel"
    segment = 128
    for part in [0..7]
      @ctx.lineWidth = 1 + values[0] * (15 + Math.random() * 5)
      @ctx.strokeStyle = @hsl 0.9 + Math.random() * 0.2, 0.8 + Math.random() * 0.1, 0.5, 0.5 # "d48"
      @ctx.beginPath()
      @ctx.moveTo(0, 0.5 * h)
      for i in [0..segment - 1]
        t = i / segment
        t = if t > 0.5 then 1 - t else t
        t = t * 3
        val = (values[part * segment + i] * t + 1) / 2
        x = w * ((i % segment) / segment)
        y = val * 2 * h - h * 0.5
        @ctx.lineTo(x, y)
      @ctx.lineTo(w, 0.5 * h)
      @ctx.stroke()

    if Loader.loading
      @ctx.fillStyle = "#aaa4"
      s = h / 6
      @ctx.fillRect(w * 0.5 - s, h * 0.5 - s, s * 2, s * 2)

  draw : () ->
    @draw_waveform(@waveform.getValue());
    requestAnimationFrame(Visual.draw.bind(Visual));
  write : (text) ->
    if @mode is "text"
      $("#screen").html text
  resize : () ->
    @ctx.canvas.width = $("#screen").width()
    @ctx.canvas.height = $("#screen").height()
  init : () ->
    if @mode is "wave"
      @waveform = new Tone.Waveform(1024)
      Tone.Master.fan @waveform
      @ctx = $("canvas").get(0).getContext("2d")
      $(window).resize Visual.resize.bind(Visual)
      @resize()
      @draw()

Player = 
  max_buffers : 32
    
  player : null
  playlist : null

  node : 
    content : new Tone.Buffer()
    outputs : [0..8].map (i) -> new Tone.Buffer()
  load_node : (n, onload) ->
    console.log n
    @reset()
    @node.content.dispose()
    content_url = "./samples/#{n.name}.mp3"
    @node.content.load content_url
                 .then (e) -> console.log "done"
                 .catch (e) -> console.log "MISSING CONTENT", content_url
    if not (@node.outputs.length is 1 and @node.outputs[0][0] is "=")
      for o, i in @node.outputs
        o.dispose()
        if i < n.outputs.length
          output_url = "./samples/#{n.outputs[i]}_info.mp3"
          o.load output_url
            .then (e) -> console.log e
            .catch (e) -> console.log "MISSING INFO", output_url

    Loader.finished onload
    # @node.samples_to_load

  toggle_compressor : (t) ->

    if t 
      @player.disconnect Tone.Master
      @player.connect @compressor
    else
      @player.disconnect @compressor
      @player.connect Tone.Master

  init : () ->
    @compressor = new Tone.Compressor().toMaster()
    @player = new Tone.Player().connect @compressor

  start : () ->
    Tone.Transport.seconds = 0
    Tone.Transport.start()
  reset : () ->
    Tone.Transport.seconds = 0
    @player.stop()
    if @playlist?
      @playlist.removeAll()
      # @playlist.dispose()


  play : (node, nointro) ->
    console.log node
    # Tone.Transport.seconds = 3
    if node.outputs.length is 0
      # DEAD END
      console.log "dead end"
      @reset()
      @load_node node, () => 
        @playlist = new Tone.Part(
          ((t, o) =>
            if !o.buffer?
              Map.open node.parent
            else
              @player.buffer = o.buffer
              @player.start()
          ),
          [
            {time : 0, buffer : @node.content}, 
            {time : @node.content.duration}
          ]
        )
        @start()
        @playlist.start Config.start_delay
    else if node.outputs.length is 1 and node.outputs[0][0] is "="
      # CONTINUE TO OUTPUT AFTER CONTENT
      @reset()
      @load_node node, () => 
        @playlist = new Tone.Part(
          ((t, o) =>
            if o.ending?
              o.ending()
            else
              if !o.buffer?
                Map.open node.outputs[0].substr(1)
              else
                @player.buffer = o.buffer
                @player.start()
          ),
          [
            {time : 0, buffer : @node.content}, 
            {time : @node.content.duration}
          ]
        )
        @start()
        @playlist.start Config.start_delay
    else
      # CLASSIC
      sum_duration = (a, v) -> a + v.buffer.duration

      @reset()
      @load_node node, () => 

        _ "all loaded starting node"
        console.log @node.content
        # _ @node.content
        # create timetable for playlist
        timetable = 
          if nointro then [] 
          else [{time : 0, buffer : @node.content}]

        # add output titles with buttons
        timetable = node.outputs.reduce(
          ((list, output, i) =>
            list.concat([
              {
                time : list.reduce(sum_duration, 0)
                buffer : @node.outputs[i]
              }
              {
                time : list.reduce(sum_duration, 0) + @node.outputs[i].duration
                buffer : Samples.buttons[i + 1]
              }
              ]
            )
          ), timetable)

        # add go-back info
        if node.name isnt "_" and not node.is_story()
          timetable.push({time : timetable.reduce(sum_duration, 0), buffer : Samples.back})

        last = timetable[timetable.length - 1]
        ending_time = last.time + last.buffer.duration

        # create tone playlist events with timetable
        @playlist = new Tone.Part(
          ((t, o) =>
            if o.buffer?
              if o.buffer.loaded
                @player.buffer = o.buffer
                @player.start()
              else
                console.log "buffer isn't loaded"
            else
              Phone.lastAction = Phone.now()
              console.log "buffer doesnt exist"
          ), 
          timetable.concat([{time:ending_time}])
        )

        # start transport and playlist
        @start()
        @playlist.start Config.start_delay


Config = 
  start_menu : "_"
  start_delay : 0.1

Map = 
  nodes : {}
  history : {}
  current : null
  load : (data) ->    
    for d in data
      @nodes[d[0]] = Node.load d
  save_action : (a) ->
    @history.actions.push a
  open : (next, nointro) ->
    node = @nodes[next]
    if node.outputs.length is 1 and node.outputs[0].substr(0, 2) is "->"
      # INSTANT FLOW
        @open node.outputs[0].substr(2), false
    else
      if @current? and @current.is_looper()
        Looper.stop()

      @current = node

      if @current.is_looper()
        Player.reset()
        i = parseInt(node.name.substr(6, 1))
        Looper.play_song i
      else
        Player.play node, nointro

      @history.actions.push next

      Visual.write @current.toString()
  start : (id) ->
    @history = 
      id : id
      start_time : new Date().getTime()
      actions : []
    @open Config.start_menu, false
  end : () ->
    @current = null
    @history.end_time = new Date().getTime()

Phone = 
  oncall : false
  lastAction : -1
  now : (time) -> 
    if time then new Date(time).getTime() 
    else new Date().getTime()
  init : () ->
    $("#phone").css "display", "flex"
    $("#phone").animate(
      top : 0
      opacity : 1
    )
    $("#time").animate(
      top : "-100%"
      opacity : 0
    )

    $(window).keydown((e) ->
      if "0123456789#*".indexOf(e.key.toLowerCase()) isnt -1
        Phone.dial e.key
    )
    $(".numpad").click((e)-> 
      k = e.currentTarget.innerHTML
      $(e.currentTarget).css("transform", "scale(0.9)")
      setTimeout((() -> $(e.currentTarget).css("transform", "scale(1.0)")), 125)
      # encode k
      # console.log "pressing button"
      Phone.dial k
    )
    $("#call").click((e) ->
      Player.player.context.resume()
      Phone.pickup("self")
    )
  pickup : (id) ->
    $("#call").hide(250)
    # $("#call").css "display", "none"
    if not @oncall
      Player.player.context.resume()
      @lastAction = -1
      @oncall = true
      Map.start id
  hangup : () ->
    Map.end()
    Looper.stop()
    @oncall = false
    Player.reset()
    Visual.write "hanged up. \npress CALL to start a new call"
    $("#call").css "display", "block"
    Server.history Map.history
  dial : (k) ->
    if @oncall
      if Loader.loading
        console.log "input ignored while loading"
      else
        @lastAction = @now()
        switch k
          when '*'
            if Map.current.parent isnt Map.current.name and not Map.current.is_story()
              Map.open Map.current.parent, true
          when 'X' then @hangup()
          when "#" 
            console.log "TODO repeat menu"
          when '0','1','2','3','4','5','6','7','8','9'
            # console.log "dialing", k
            if Map.current? and Map.current.is_looper()
              Looper.toggle parseInt(k)
            else
              next = Map.current.get_output (if k is 0 then 0 else k - 1)
              if next?
                Map.open next, false
Server = 
  socket : null
  init : () -> 
    @socket = io()
    # if @socket.connected
    @socket.on "incomingDigit", Phone.dial.bind(Phone)
    @socket.on "hangup", Phone.hangup.bind(Phone)
    @socket.on "pickup", ((number) -> 
      setTimeout((() -> Phone.pickup.bind(Phone)(number)), 1000)
      console.log "picking up"
    )
    # else 
    #   @socket.disconnect()
  history : (history) ->  
    if @socket.connected
      @socket.emit "history", history

initialized = false
init = () ->
  Tone.Buffer.off "load"
  console.log "initing solvator"
  Player.init()
  Phone.init()
  Server.init()
  Visual.init()


Samples.load init

# IdleWatcher = null
# IdleWatcher = window.setInterval(watchIdle, 1000)

# watchIdle = () ->
#   kickTime = 60000
#   millisToSec = (ms) -> Math.abs(Math.floor(0.001 * ms)) + "s"
#   t = ""
#   if not Phone.oncall and Map.history?
#     t = "last call was " + millisToSec(Phone.now() - Phone.now(Map.history.end_time)) + " ago"
#   else if Phone.oncall
#     et = millisToSec(Phone.now() - Phone.now(Map.history.start_time))
#     t = "call time : #{et}"
#   if LastTimePartEnded isnt -1
#     kt = millisToSec(Phone.now() - (LastTimePartEnded + kickTime) )
#     t = t + "  --- hanging up in : #{kt}"
#     if Phone.now() > LastTimePartEnded + kickTime
#       hangup()
#   $("#time").html t


###
TODO

kick idle

low performance visual

gui buttons # call hangup

add compressor on speech/looper?

looper 5 fix clipping sample

FELVETEL

looper explain back

###
